<template>
  <div>
    <vx-card class="mb-4">
      <h4 class="mb-1">{{ $t('influencer.approvals') }}</h4>
      <small class="text-muted d-block mb-3">{{ $t('influencer.approvals_hint') }}</small>

      <div v-if="isLoading" class="text-center py-4">
        <span class="text-muted">{{ $t('loading') }}</span>
      </div>

      <div v-else-if="!pending.length" class="text-center py-4">
        <feather-icon icon="CheckCircleIcon" class="h-8 w-8 text-success mb-1"/>
        <p class="text-muted mb-0">{{ $t('influencer.approvals_empty') }}</p>
      </div>

      <div v-else>
        <div v-for="item in pending" :key="item.id" class="approval-row">
          <div class="approval-main">
            <div class="font-medium">{{ item.name }}</div>
            <small class="text-muted d-block">{{ item.email }}</small>

            <div class="mt-1">
              <vs-chip
                v-for="p in (item.social_profiles || [])"
                :key="p.id"
                transparent
                color="primary"
                class="mr-1">
                <a :href="p.profile_url" target="_blank" rel="noopener noreferrer">
                  {{ p.network_label }} @{{ p.handle }}
                </a>
                <span v-if="p.followers"> · {{ formatFollowers(p.followers) }}</span>
              </vs-chip>
            </div>

            <p v-if="item.bio" class="mt-1 mb-0 text-muted small">{{ item.bio }}</p>

            <small class="text-muted d-block mt-1">
              {{ $t('influencer.source') }}: {{ $t(`influencer.source_.${item.source}`) }}
              · {{ $t('influencer.applied_at') }}: {{ formatDate(item.created_at) }}
            </small>
          </div>

          <div class="approval-actions">
            <b-button size="sm" variant="success" :disabled="busyId === item.id" @click="approve(item)">
              <feather-icon icon="CheckIcon" class="mr-25"/>{{ $t('influencer.approve') }}
            </b-button>
            <b-button size="sm" variant="outline-danger" :disabled="busyId === item.id" @click="openReject(item)">
              <feather-icon icon="XIcon" class="mr-25"/>{{ $t('influencer.reject') }}
            </b-button>
          </div>
        </div>
      </div>
    </vx-card>

    <b-modal
      v-model="rejectModal"
      :title="$t('influencer.reject')"
      :ok-title="$t('influencer.reject')"
      :cancel-title="$t('cancel')"
      ok-variant="danger"
      @ok="confirmReject">
      <b-form-group :label="$t('influencer.reject_reason')" label-for="reject_reason">
        <b-form-textarea id="reject_reason" v-model="rejectReason" rows="3"/>
        <small class="text-muted">{{ $t('influencer.reject_reason_hint') }}</small>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, BFormGroup, BFormTextarea } from 'bootstrap-vue'
import InfluencerService from '@/services/api/InfluencerService'

export default {
  components: { BButton, BModal, BFormGroup, BFormTextarea },
  data: () => ({
    service: null,
    pending: [],
    isLoading: false,
    busyId: null,
    rejectModal: false,
    rejectReason: '',
    rejecting: null
  }),
  methods: {
    load() {
      this.isLoading = true
      this.service.pending().then(
        list => { this.pending = list || [] },
        () => { this.pending = [] }
      ).finally(() => { this.isLoading = false })
    },
    approve(item) {
      this.busyId = item.id
      this.service.approve(item.id).then(
        () => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.load()
        },
        error => this.showErrors(this.$validator, error, this)
      ).finally(() => { this.busyId = null })
    },
    openReject(item) {
      this.rejecting = item
      this.rejectReason = ''
      this.rejectModal = true
    },
    confirmReject() {
      if (!this.rejecting) return
      const id = this.rejecting.id
      this.busyId = id
      this.service.reject(id, this.rejectReason).then(
        () => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.load()
        },
        error => this.showErrors(this.$validator, error, this)
      ).finally(() => { this.busyId = null; this.rejecting = null })
    },
    formatFollowers(value) {
      const n = Number(value || 0)
      return n >= 1000 ? `${(n / 1000).toFixed(1).replace('.0', '')}k` : String(n)
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString('pt-BR') : ''
    }
  },
  beforeMount() {
    this.service = InfluencerService.build(this.$vs)
  },
  mounted() {
    this.load()
  }
}
</script>

<style scoped>
.approval-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.approval-row:last-child {
  border-bottom: none;
}

.approval-main {
  flex: 1;
  min-width: 0;
}

.approval-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}
</style>
